<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div class="bodyCenter">
      <div class="modalStyle">
        <b-row class="titulo">
          <b-col class="seccionTitulo">
            <span class="fa fa-table"></span>
            <span>Reporte de seguimiento Ptis</span>
          </b-col>
          <b-col class="seccionCodigo">
            <div>Rep_PTI_M2</div>
          </b-col>
        </b-row>

        <b-tabs content-class="mt-3" fill>
          <div class="flxDivs">
            <div>
              <b-tabs content-class="mt-3" fill>
                <b-tab v-if="$localStorageService.can('Rep_UP_M2_presup')" title="Ptis Presupuestados por CDXE">
                  <reportePtiPresupuestadoCDXEV2/>
                </b-tab>
                <b-tab v-if="$localStorageService.can('Rep_UP_M2_rev')" title="Ptis en revisión">
                  <reportePtiRevisionV2/>
                </b-tab>
                <b-tab v-if="$localStorageService.can('Rep_UP_M2_present')" title="Ptis presentados">
                  <reportePtiPresentadosV2/>
                </b-tab>
                <b-tab v-if="$localStorageService.can('Rep_UP_M2_acept')" title="Ptis aceptados">
                  <reportePtiAceptadosV2/>
                </b-tab>
                <b-tab v-if="$localStorageService.can('Rep_UP_M2_acept')" title="Ptis no aceptados">
                  <reportePtiAceptadosV2 :estatus="2"/>
                </b-tab>
                <b-tab  v-if="$localStorageService.can('Rep_UP_M2_invers')"  title="Ptis en inversión">
                  <reportePtiInversionV2/>
                </b-tab>
              </b-tabs></div>
          </div>

        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import reportePtiPresupuestadoCDXEV2 from "./reportePtiPresupuestadoCDXEV2";
import reportePtiAceptadosV2 from "./reportePtiAceptadosV2";
import reportePtiInversionV2 from "./reportePtiInversionV2";
import reportePtiPresentadosV2 from "./reportePtiPresentadosV2";
import reportePtiRevisionV2 from "@/views/Reportes/PTIS_NM2/reportePtiRevisionV2";

export default {
  name: "reporteEscenariosPTIs",

  components: {
    Header,
    reportePtiPresupuestadoCDXEV2,
    reportePtiAceptadosV2,
    reportePtiInversionV2,
    reportePtiPresentadosV2,
    reportePtiRevisionV2,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),

  methods: {},
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>